<template>
	<div>
		<Toolbar class="p-mb-4">
			<template v-slot:left>
				<Button label="返回" icon="pi pi-arrow-left" class="p-button-warning p-mr-3" @click="$router.go(-1)" />
			</template>
		</Toolbar>

		<ProposalData :proposal="data" />
	</div>
</template>

<script>
import ProposalService from '../service/ProposalService';
import ProposalData from './ProposalData';

export default {
	data() {
		return {
			data: {}
		}
	},

	proposalService: null,

	created() {
		this.proposalService = new ProposalService();
	},

	mounted() {
		this.fetchProposal();
	},

	methods: {
		fetchProposal() {
			// Creating proposal
			if(this.$route.params.id === 'new')  return;

			// Editing proposal
            this.proposalService.findSingleProposal(this.$route.params.id)
            .then(proposal => {
                this.data = proposal;
            });
        }
	},

	components: {
        'ProposalData': ProposalData,
	},

	computed: {
        
    }
}
</script>
